module.exports = __webpack_public_path__ + "img/sys_three.66da6a28.png";